import { createMotivoNotificacaoApi } from "@/contexts/laboratorio/motivoNotificacao/api/motivoNotificacaoApi";
import { MotivoNotificacao } from "@/contexts/laboratorio/motivoNotificacao/model/MotivoNotificacao";
import {
  getMotivosNotificacaoSynced,
  motivoNotificacaoAction,
} from "@/contexts/laboratorio/motivoNotificacao/store/motivoNotificacaoSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useMotivoNotificacao = () => {
  const { user } = useAuth();
  const motivoNotificacaoApi = createMotivoNotificacaoApi(user?.access_token);
  const appDispatch = useDispatch();
  const { sync } = motivoNotificacaoAction;
  const listaMotivosNotificacao = useSelector(getMotivosNotificacaoSynced);
  const motivosNotificacaoOptions = listaMotivosNotificacao.map((motivo) => ({
    label: (motivo.nome ?? "").toUpperCase(),
    value: motivo.id,
  }));

  const sincronizarMotivosNotificacao = (items: MotivoNotificacao[]) => {
    appDispatch(sync(items));
  };

  const getMotivosNotificacaoApi = motivoNotificacaoApi.listAll;

  return {
    sincronizarMotivosNotificacao,
    listaMotivosNotificacao,
    getMotivosNotificacaoApi,
    motivosNotificacaoOptions,
  };
};
